import * as React from 'react';
import { BwjInput } from '../../entities/bwj-input';
import { deepClone } from '../../utils';
import { BwjInputBaseComponent, IBwjInputProps, IBwjInputState } from '../bwj-input-base';
import { BwjTextFieldType } from './field-type';
import { BwjTextFieldUI } from './ui';
import { IStyleFunctionOrObject, ITextFieldStyleProps, ITextFieldStyles } from '@fluentui/react';

export interface IBwjTextFieldProps extends IBwjInputProps<string> {
    filter?:RegExp;
    placeholder?: string;
    multiline?: boolean;
    fieldType?: BwjTextFieldType;
    updateOnAnyChange?: boolean; // normally, we only update on blur (when field loses focus)
    styles?: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> | undefined
}

interface IState extends IBwjInputState<string> {}

export class BwjTextField extends BwjInputBaseComponent<string, IBwjTextFieldProps, IState> {
    constructor(props: IBwjTextFieldProps) {
      super(props);

      this.handleChange = this.handleChange.bind(this);

      this.state = {
          input: !!props.input ? props.input : new BwjInput<string>(''),
      };
    }

    protected handleComponentDidMount() {
        this.setState({
            input: !!this.props.input ? this.props.input : new BwjInput<string>(''),
        });
    }

    protected handleComponentDidUpdate(prevProps?: IBwjTextFieldProps | undefined, prevState?: IState | undefined): void {
        if(this.updateFieldOnThisCycle) {
            this.updateInputField();
            this.updateFieldOnThisCycle = false;
        }
    }

    protected valuesAreEqual(prev: string | null, current: string | null) {
        return prev === current;
    }

    private handleChange(e:React.ChangeEvent<HTMLFormElement>) {
        const value = e.target.value as string;
        // if a filter is in use, a value change only occurs if the new value is valid
        const valueUnchanged = !!this.props.filter && !this.props.filter.test(value);

        this.setState(prev => {
            if(valueUnchanged) {
                return prev;
            }

            let state = deepClone(prev) as unknown as IState;
            state.input.value = value;

            return state;
        });

        if(valueUnchanged === false && this.props.updateOnAnyChange) {
            this.updateFieldOnThisCycle = true;
        }
    }

    private updateFieldOnThisCycle: boolean = false;
  
    public render() {
      const p = this.props;
      const s = this.state;
      return (
        <BwjTextFieldUI   id={p.id}
                            required={p.required}
                            label={p.label}
                            placeholder={p.placeholder}
                            onChange={this.handleChange}
                            onFocus={this.focusHandler}
                            onBlur={this.blurHandler}
                            input={s.input}
                            multiline={p.multiline}
                            fieldType={p.fieldType}
                            styles={p.styles} />
      );
    }
  }